import { apiClient } from '_app'
import { CancelToken } from 'axios'
import {
  ApiResponse,
  MichiganTitleCreateDto,
  MichiganTitleDto,
  MichiganTitleVehicleApplicationReadyToPrintDto,
  MichiganTitleVehicleDto,
  MichiganTitleVehiclePoliceBookDto,
  VehicleDto
} from 'dtos'
import { MichiganTitlesParameters, PaginationParameters } from 'parameters'
import { URIQuery } from 'utils'

export const getMichiganTitleVehicles = (parameters: PaginationParameters, cancelToken?: CancelToken) =>
  apiClient
    .get<ApiResponse<MichiganTitleVehicleDto[]>>('/api/michigan-titles/vehicles' + URIQuery(parameters), { cancelToken })
    .then(res => res.data)

export const saveMichiganTitleApplicationPacket = (values: MichiganTitleVehicleDto, cancelToken?: CancelToken) =>
  apiClient
    .put<ApiResponse<MichiganTitleVehicleDto>>('/api/michigan-titles/michigan-title-application-packet', values, {
      cancelToken
    })
    .then(res => res.data)

export const getMichiganTitlePoliceBook = (cancelToken?: CancelToken) =>
  apiClient
    .get<ApiResponse<MichiganTitleVehiclePoliceBookDto[]>>('/api/michigan-titles/police-book', { cancelToken })
    .then(res => res.data)

export const saveMichiganTitlePoliceBook = (values: MichiganTitleVehiclePoliceBookDto[], cancelToken?: CancelToken) =>
  apiClient
    .put<ApiResponse<MichiganTitleVehiclePoliceBookDto[]>>('/api/michigan-titles/police-book', values, { cancelToken })
    .then(res => res.data)

export const getApplicationReadyToPrint = (includeApplicationPacketsReadyForMISoSBundle: boolean, cancelToken?: CancelToken) =>
  apiClient
    .get<ApiResponse<MichiganTitleVehicleApplicationReadyToPrintDto[]>>(
      `/api/michigan-titles/application-ready-to-print?includeApplicationPacketsReadyForMISoSBundle=${includeApplicationPacketsReadyForMISoSBundle}`,
      {
        cancelToken
      }
    )
    .then(res => res.data)

export const putApplicationReadyToPrint = (
  values: MichiganTitleVehicleApplicationReadyToPrintDto[],
  includeApplicationPacketsReadyForMISoSBundle: boolean,
  cancelToken?: CancelToken
) =>
  apiClient
    .put<ApiResponse<MichiganTitleVehicleApplicationReadyToPrintDto[]>>(
      `/api/michigan-titles/application-ready-to-print?includeApplicationPacketsReadyForMISoSBundle=${includeApplicationPacketsReadyForMISoSBundle}`,
      values,
      {
        cancelToken
      }
    )
    .then(res => res.data)

export const generateApplicationPacket = (
  values: MichiganTitleVehicleApplicationReadyToPrintDto[],
  cancelToken?: CancelToken
) =>
  apiClient
    .post('/api/michigan-titles/generate-application-packet', values, { cancelToken, responseType: 'blob' })
    .then(res => {
      const blob = new Blob([res.data], { type: (res.headers['content-type'] ?? undefined) as string | undefined })
      const objectURL = URL.createObjectURL(blob)
      window.open(objectURL, '_blank')
    })

// DELETE AFTER ME
export const getMichiganTitles = (parameters: MichiganTitlesParameters) =>
  apiClient
    .get<ApiResponse<MichiganTitleDto[]>>('/api/michigan-titles' + URIQuery({ ...parameters }))
    .then(response => response.data)

export const getMichiganTitle = (michiganTitleGuid: string) =>
  apiClient
    .get<ApiResponse<MichiganTitleDto>>(`/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}`)
    .then(resoponse => resoponse.data)

export const getMichiganTitleByVehicleGuid = (vehicleGuid: string) =>
  apiClient
    .get<ApiResponse<MichiganTitleDto>>(`/api/michigan-titles/by-vehicle/${encodeURIComponent(vehicleGuid)}`)
    .then(response => response.data)

export const getMichiganVehicles = (parameters: MichiganTitlesParameters) =>
  apiClient
    .get<ApiResponse<VehicleDto[]>>(`/api/michigan-titles/vehicles` + URIQuery({ ...parameters }))
    .then(response => response.data)

// export const createMichiganTitle = (michiganTitle: MichiganTitleDto) =>
//   apiClient.post<ApiResponse<MichiganTitleDto>>('/api/michigan-titles', michiganTitle).then(response => response.data)

export const createMichiganTitle = (payload: MichiganTitleCreateDto) =>
  apiClient.post<ApiResponse<MichiganTitleDto>>('/api/michigan-titles', payload).then(response => response.data)

// export const updateMichiganTitle = (michiganTitleGuid: string) =>
//   apiClient
//     .put<ApiResponse<MichiganTitleDto>>(`/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}`)
//     .then(response => response.data)

export const updateMichiganTitle = (michiganTitleGuid: string, data: MichiganTitleDto) =>
  apiClient
    .put<ApiResponse<MichiganTitleDto>>(`/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}`, data, {
      headers: {
        'Content-Type': 'application/json'
      }
    })
    .then(response => response.data)

export const updatePoliceBookNumber = (michiganTitleGuid: string, policeBookNumber: string) =>
  apiClient
    .put<ApiResponse<MichiganTitleDto>>(
      `/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}/police-book-number`,
      policeBookNumber,
      {
        headers: {
          'Content-Type': 'application/json'
        }
      }
    )
    .then(response => response.data)

export const addAsSpecialMailer = (
  michiganTitleGuid: string,
  payload: {
    specialMailerName: string
    specialMailerAddress1?: string
    specialMailerCity?: string
    specialMailerStateProvince?: string
    specialMailerPostalCode?: string
  }
) =>
  apiClient
    .put<ApiResponse<MichiganTitleDto>>(
      `/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}/add-as-special-mailer`,
      payload
    )
    .then(response => response.data)

export const addAsOwner = (
  michiganTitleGuid: string,
  payload: {
    ownerName: string
    ownerAddress1?: string
    ownerCity?: string
    ownerStateProvince?: string
    ownerPostalCode?: string
  }
) =>
  apiClient
    .put<ApiResponse<MichiganTitleDto>>(`/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}/add-as-owner`, payload)
    .then(response => response.data)

export const saveAndMarkApplicationPacketReadyToPrint = (michiganTitleGuid: string) =>
  apiClient
    .put<ApiResponse<MichiganTitleDto>>(
      `/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}/save-and-mark-application-packet-ready-to-print`
    )
    .then(response => response.data)

export const markSelectedVehiclesApplicationReadyForMiSosBundle = (michiganTitleGuid: string) =>
  apiClient
    .put<ApiResponse<MichiganTitleDto>>(
      `/api/michigan-titles/${encodeURIComponent(michiganTitleGuid)}/mark-selected-vehicles-application-ready-for-mi-sos-bundle`
    )
    .then(response => response.data)
